<div class="card-body">
    <div class="row animated-row" *ngIf="!insurance">
        <ng-container *ngFor="let insuranceL of insurances">
            <div class="col-md-6 col-lg-4 col-xxxl-3 p-3" role="button"
                (click)="viewInsuranceHandler(insuranceL?.insuranceId)">
                <div class="card-box">
                    <dynamic-field [props]="props.Type" [canBeEmpty]="true">
                        <div HJSuppress class="card-type-box insurance-status-text"
                            [ngClass]="'status-'+(insuranceL.status).toLowerCase()"
                        >
                            {{insuranceL?.type}}
                        </div>
                    </dynamic-field>
                    <dynamic-field [props]="props.InsurerName" [canBeEmpty]="true">
                        <div HJSuppress class="card-insurer-name">
                            {{insuranceL?.insurerName}}
                        </div>
                    </dynamic-field>
                    <dynamic-field [props]="props.EndDate" [canBeEmpty]="true">
                        <div class="card-valability-box my-4 fw-semibold">
                            {{'contractDetail.insurances.valability' | translate}}
                            <span HJSuppress class="card-valability-value fw-bold insurance-status-text"
                                [ngClass]="'status-'+(insuranceL.status).toLowerCase()"
                            >
                                {{insuranceL?.endDate | localizedDate}}
                            </span>
                        </div>
                    </dynamic-field>
                    <dynamic-field [props]="props.Asset" [canBeEmpty]="true">
                        <div HJSuppress class="d-flex flex-column gap-1">
                            <span class="card-asset-name">{{insuranceL?.asset?.name}}</span>
                            <span class="card-asset-number fw-bold">
                                {{insuranceL?.asset?.number}}
                            </span>
                        </div>
                    </dynamic-field>
                    <dynamic-field [props]="props.Status" [canBeEmpty]="true">
                        <div class="insurance-status-box justify-content-center my-3">
                            <div class="insurance-status-dot"
                                [ngClass]="'status-'+(insuranceL.status).toLowerCase()"
                            >
                            </div>
                            <div class="insurance-status-value">
                                {{ 'insurance.insuranceList.insuranceStatus.'+(insuranceL.status).toLowerCase() | translate }}
                            </div>
                        </div>
                    </dynamic-field>
                </div>
            </div>
        </ng-container>
    </div>

    <div class="insurance-detail" *ngIf="insurance">
        <button class="btn link-btn btn-back-txt mb-5" (click)="returnHandler()">
            <i class="app-icon icon icon-arrow-left icon-xl me-2"></i>
            <span>{{'contractDetail.insurances.return' | translate}}</span>
        </button>

        <div class="row animated-row mb-4">
            <div HJSuppress class="col-md-6 text-center text-md-start">
                <div class="d-flex flex-column gap-3">
                    <div class="detail-type fw-bold">{{insurance?.type}}</div>
                    <div class="insurance-status-box">
                        <div class="insurance-status-dot"
                            [ngClass]="'status-'+(insurance.status).toLowerCase()"
                        >
                        </div>
                        <div class="insurance-status-value">
                            {{ 'insurance.insuranceList.insuranceStatus.'+(insurance.status).toLowerCase() | translate }}
                        </div>
                    </div>
                </div>
            </div>
            <div HJSuppress class="col-md-6 detail-insurer-name text-center text-md-end">
                {{insurance?.insurerName}}
            </div>
        </div>
        <div class="row animated-row mb-4">
            <div class="col-md-6 detail-policy text-center text-md-start">
                {{'contractDetail.insurances.policy' | translate}}:
                <span HJSuppress class="detail-policy-value">
                    {{insurance?.policy}}
                </span>
            </div>
            <div class="col-md-6 text-center text-md-end">
                <dynamic-field [props]="props.Premium" [canBeEmpty]="true">
                    <div class="detail-valability">
                        {{'contractDetail.insurances.premium' | translate}}:
                        <span HJSuppress class="detail-policy-value">
                            {{insurance?.premium | number:'1.0'}} {{insurance?.currency}}
                        </span>
                    </div>
                </dynamic-field>
            </div>
        </div>
        <div class="row animated-row">
            <div class="col-md-6 text-center text-md-start">
                <dynamic-field [props]="props.Valability" [canBeEmpty]="true">
                    <div class="detail-valability text-center text-md-start">
                        {{'contractDetail.insurances.valability' | translate}}:
                        <span HJSuppress class="text-primary fw-bold">
                            {{insurance?.endDate | localizedDate}}
                        </span>
                    </div>
                </dynamic-field>
            </div>
            <div class="col-md-6 text-center text-md-end">
                <dynamic-field [props]="props.PremiumCount" [canBeEmpty]="true">
                    <div class="detail-valability">
                        {{'contractDetail.insurances.premiumCount' | translate}}:
                        <span HJSuppress class="detail-policy-value">
                            {{insurance?.premiumCount}}
                        </span>
                    </div>
                </dynamic-field>
            </div>
        </div>
        <div class="row animated-row">
            <div class="col-12 no-point text-center text-md-start">
                {{'contractDetail.insurances.assets' | translate}}
            </div>
        </div>
        <div class="row animated-row">
            <dynamic-field class="col-12 detail-table" [props]="props.Asset" [canBeEmpty]="true">
                <div class="detail-table table-wtd">
                    <div HJSuppress class="detail-valability">
                        {{insurance?.asset?.name}}
                    </div>
                    <div HJSuppress class="detail-policy-value">
                        {{insurance?.asset?.number}}
                    </div>
                    <div class="detail-valability">
                        {{'contractDetail.insurances.vin' | translate}}:
                        <span HJSuppress class="detail-policy-value">
                            {{insurance?.asset?.vin}}
                        </span>
                    </div>
                </div>
            </dynamic-field>
        </div>
        <div class="row animated-row">
            <dynamic-field class="col-12 text-end" [props]="props.IssuedOn" [canBeEmpty]="true">
                <div class="issued-date">
                    {{'contractDetail.insurances.validFrom' | translate}}:
                    <span HJSuppress class="issued-date-value">
                        {{insurance?.issuedOn | localizedDate}}
                    </span>
                </div>
            </dynamic-field>
        </div>
    </div>
</div>
